import { render, staticRenderFns } from "./Taslim.vue?vue&type=template&id=3297af1f&scoped=true"
import script from "./Taslim.vue?vue&type=script&lang=js"
export * from "./Taslim.vue?vue&type=script&lang=js"
import style0 from "./Taslim.vue?vue&type=style&index=0&id=3297af1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3297af1f",
  null
  
)

export default component.exports